import { useMutation, UseMutationOption } from 'src/hooks/use-mutation'
import { GqlError, SendWorksheetDocument } from 'src/lib/gql-client'
import { graphqlRequest } from 'src/lib/gql-client/request'

import { Worksheet } from '../../types'

const sendWorksheet = async ({
  worksheetUid,
}: {
  worksheetUid: Worksheet['uid']
}): Promise<void> => {
  try {
    await graphqlRequest(SendWorksheetDocument, {
      worksheetUid,
    })
  } catch (error) {
    throw error
  }
}

export const useSendWorksheet = (
  options?: UseMutationOption<void, GqlError>,
) => {
  return useMutation(
    ({ worksheetUid }: { worksheetUid: Worksheet['uid'] }) =>
      sendWorksheet({ worksheetUid }),
    options,
  )
}
